<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class="" cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px; padding-top: 40px; padding-bottom: 100px"
        class="term_service"
      >
        <h1>Truthbrush Terms of Services</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <h1>Introduction</h1>
        <p>
          Please read these Terms of Service (these "Terms") carefully as they
          govern your use of (which includes access to) Truthbrush's
          personalized services for teeth brushing tracking and other content
          and services, including all of our websites and software applications
          that incorporate or link to these Terms (collectively, the "Truthbrush
          Service") and any material that is made available through the
          Truthbrush Service (the "Content").
        </p>

        <p>
          Use of the Truthbrush Service may be subject to additional terms and
          conditions presented by Truthbrush, which are hereby incorporated by
          this reference into these Terms.
        </p>

        <p>
          By purchasing, signing up for, or otherwise using, the Truthbrush
          Service, you agree to these Terms. If you do not agree to these Terms,
          then you must not use the Truthbrush Service or access any Content.
        </p>

        <p>
          THESE TERMS CONTAIN A MANDATORY ARBITRATION PROVISION THAT, AS FURTHER
          SET FORTH BELOW, REQUIRES THE USE OF ARBITRATION ON AN INDIVIDUAL
          BASIS TO RESOLVE DISPUTES, RATHER THAN JURY TRIALS OR ANY OTHER COURT
          PROCEEDINGS, OR CLASS ACTIONS OF ANY KIND.
        </p>
        <h4>Service Provider</h4>
        <p>
          These Terms are between you and the makers of Truthbrush branded
          products, Candibell, Inc 600 Suffolk St #250, Lowell, MA 01854.
        </p>
        <h4>Age and Eligibility Requirements</h4>
        <p>
          BY USING THE TRUTHBRUSH SERVICE, YOU AFFIRM THAT YOU ARE 18 YEARS OR
          OLDER TO ENTER INTO THESE TERMS.
        </p>

        <h1>The Truthbrush Service Provided by Us</h1>
        <h4>Precautions</h4>
        <p>
          THE TRUTHBRUSH SERVICES ARE NOT A MEDICAL OR DENTAL DEVICE AND YOU
          EXPRESSLY AGREE THAT THE SERVICES DO NOT INVOLVE THE PROVISION OF
          MEDICAL OR DENTAL ADVICE BY TRUTHBRUSH (CANDIBELL, INC). THE SERVICES
          ARE NOT INTENDED TO DIAGNOSE, TREAT, CURE, OR PREVENT ANY DISEASE OR
          MEDICAL OR DENTAL CONDITION. THE SERVICES ARE FOR INFORMATIONAL
          PURPOSES ONLY AND CANNOT REPLACE THE SERVICES OF MEDICAL OR DENTAL
          PROFESSIONALS.
        </p>
        <p>
          THE SERVICES, INCLUDING ALL INFORMATION, TEXT, PHOTOGRAPHS, IMAGES,
          ILLUSTRATIONS, GRAPHICS, AUDIO, VIDEO, AND AUDIO-VIDEO CLIPS, AND
          OTHER MATERIALS, WHETHER PROVIDED BY US OR THIRD PARTIES, IS NOT
          INTENDED TO BE AND SHOULD NOT BE USED IN PLACE OF (a) THE ADVICE OF
          YOUR MEDICAL OR DENTAL PROFESSIONAL, (b) A VISIT, CALL, OR
          CONSULTATION WITH YOUR MEDICAL OR DENTAL PROFESSIONAL OR OTHER MEDICAL
          OR DENTAL PROFESSIONALS, OR (c) INFORMATION CONTAINED ON OR IN ANY
          PRODUCT PACKAGING OR LABEL.
        </p>
        <p>
          SHOULD YOU HAVE ANY HEALTH-RELATED QUESTIONS, PLEASE CALL OR SEE YOUR
          MEDICAL OR DENTAL PROFESSIONAL OR OTHER MEDICAL OR DENTAL PROVIDER
          PROMPTLY. SHOULD YOU HAVE AN EMERGENCY, CALL YOUR MEDICAL OR DENTAL
          PROFESSIONAL OR 911 IMMEDIATELY. YOU SHOULD NEVER DISREGARD MEDICAL OR
          DENTAL ADVICE OR DELAY IN SEEKING MEDICAL OR DENTAL ADVICE BECAUSE OF
          ANY INFORMATION PRESENTED ON THE SERVICES, AND YOU SHOULD NOT USE THE
          SERVICES OR ANY INFORMATION PROVIDED IN THE SERVICES FOR DIAGNOSING OR
          TREATING A MEDICAL OR DENTAL PROBLEM. THE TRANSMISSION AND RECEIPT OF
          SERVICES, IN WHOLE OR IN PART, OR COMMUNICATION VIA THE INTERNET,
          EMAIL, OR OTHER MEANS DOES NOT CONSTITUTE OR CREATE A HEALTH CARE
          PROFESSIONAL-PATIENT OR THERAPIST-PATIENT RELATIONSHIP BETWEEN YOU AND
          TRUTHBRUSH (CANDIBELL, INC).
        </p>
        <p>
          You should always consult a medical or dental professional before
          making any changes to your oral care activity based on information
          provided through the Services, or if you have any questions regarding
          a health or dental condition. Truthbrush (Candibell, Inc) is not
          responsible for any health or dental problems that may result from
          information you learn about through the Services. If you make any
          change to your oral care or activity based on the Services, you agree
          that you do so fully at your own risk. It is important to be sensitive
          to your body's responses. The information in the Services may be
          misleading if your physiological functions and responses differ
          significantly from population averages due to medical or dental
          conditions or rare natural differences.
        </p>
        <p>
          OUR PRODUCTS SHOULD NOT BE PLACED IN THE MOUTH AT ANY TIME. TRUTHBRUSH
          (CANDIBELL, INC)’S PRODUCT IS NOT A TOY NOR IS IT INTENDED FOR USE BY
          CHILDREN UNDER 3. ADULT SUPERVISION IS REQUIRED, AS IT MAY POSE A
          CHOKING HAZARD. THE PRODUCT MAY CONTAIN SMALL COMPONENTS SUCH AS
          BATTERY AND SMALL PARTS THAT MAY REPRESENT A RISK FACTOR FOR CHILDREN.
          YOU HEREBY ACKNOWLEDGE THESE POTENTIAL RISK FACTORS AND AGREE TO USE
          OUR PRODUCTS AT YOUR OWN RISK.
        </p>

        <h1>Truthbrush Service Options</h1>
        <p>
          We provide numerous Truthbrush Service options. Certain Truthbrush
          Service options are provided free-of-charge, while other options
          require payment before they can be accessed (the "Paid
          Subscriptions"). We may also offer special promotional plans,
          memberships, or services, including offerings of third-party products
          and services. We are not responsible for the products and services
          provided by such third parties.
        </p>
        <h4>Trials</h4>
        <p>
          From time to time, we or others on our behalf may offer trials of Paid
          Subscriptions for a specified period without payment or at a reduced
          rate (a "Trial"). By using a Truthbrush Service via a Trial, you agree
          to the Truthbrush Promotional Offer Terms.
        </p>
        <h4>Third-Party Applications, Devices and Open Source Software</h4>

        <p>
          The Truthbrush Service may be integrated with, or may otherwise
          interact with, third-party applications, websites, and services
          ("Third-Party Applications") and third-party personal computers,
          mobile handsets, tablets, wearable devices, speakers, and other
          devices ("Devices"). Your use of such Third-Party Applications and
          Devices may be subject to additional terms, conditions, and policies
          provided to you by the applicable third party. Truthbrush does not
          guarantee that Third-Party Applications and Devices will be compatible
          with the Truthbrush Service.
        </p>
        <h4>Service Limitations and Modifications</h4>

        <p>
          We use reasonable efforts to keep the Truthbrush Service operational
          and to provide you with a personalized oral care tracking experience.
          However, our service offerings and their availability may change from
          time to time, without liability to you; for example:
        </p>
        <p>
          The Truthbrush Services may experience temporary interruptions due to
          technical difficulties, maintenance or testing, or updates, including
          those required to reflect changes in relevant laws and regulatory
          requirements.
        </p>
        <p>
          We aim to evolve and improve the Truthbrush Service constantly, and we
          may modify, suspend, or stop (permanently or temporarily) providing
          all of part of the Truthbrush Service (including particular functions,
          hardware, features, subscription plans, pricing & bundle options, and
          promotional offerings); Truthbrush (Candibell, Inc) has no obligation
          to provide any specific content through the Truthbrush Service, and
          Truthbrush (Candibell, Inc) or the applicable owners may remove
          particular content without notice.
        </p>
        <p>
          Truthbrush has no liability to you, nor any obligation to provide a
          refund to you, in connection with internet or other cloud service
          outages or failures that are caused by the actions of government
          authorities, other third parties (including cloud service providers), failure to keep devices in proper
          working order (eg. with a fully charged battery) or events beyond our
          control.
        </p>

        <h1>Your Use of the Truthbrush Service</h1>
        <h4>Creating a Truthbrush account</h4>
        <p>
          You will need to create a Truthbrush account to use all or part of the
          Truthbrush Service. Your username and password are for your personal
          use only and should be kept confidential. You understand that you are
          responsible for the complexity of as well as all use (including any
          unauthorized use) of your username and password. Notify our Customer
          Service team immediately (support@truthbrush.com) if your username or
          password is lost or stolen, or if you believe there has been
          unauthorized access to your account.
        </p>
        <p>
          Truthbrush (Candibell, Inc) may reclaim, or require you to change,
          your username for any reason.
        </p>
        <p>
          You are solely responsible for maintaining the confidentiality of the
          password associated with your account and for restricting access to
          your password, your computer and mobile device while logged into the
          Services. You accept responsibility for all activities that occur
          under your account or from your computer and mobile devices. We
          endeavor to use reasonable security measures to protect against
          unauthorized access to your account. We cannot, however, guarantee
          absolute security of your account, your content or the personal
          information you provide, and we cannot promise that our security
          measures will prevent third-party “hackers” from illegally accessing
          the Services or its contents. You agree to immediately notify
          Truthbrush of any unauthorized use of your account or password, or any
          other breach of security, and confirm that you understand all risks of
          unauthorized access to Member Data and any other information or
          content you provide to Truthbrush.
        </p>
        <p>
          You may register for or log-in to your account via a third-party
          network, such as Facebook or Google. If you do so, you hereby
          authorize Truthbrush to pre-populate the registration and other
          relevant information fields of your account and/or to use such
          third-party credentials to log you into your account. If you connect
          your account to a third-party network, you agree to comply with the
          terms and conditions and policies applicable to such third party.
        </p>

        <p>
          You may need to provide us with your name, phone number, email and/or
          address information (Fulfillment Information) in order for us to
          fulfill your Truthbrush order. We endeavor to apply reasonable
          security measures to protect the confidentiality and integrity of the
          data. However, we cannot guarantee the consistency and accuracy of
          such fulfillment information you provided to us when making a
          purchase. It is therefore essential that you make sure the fulfillment
          information you provided to us is up to date and accurate. Once an
          order is shipped, we generally are unable to retrieve the order and
          therefore are unable to cover the cost of loss if the fulfillment
          information is inaccurate.
        </p>
        <h4>Access to the Truthbrush Services</h4>
        <p>
          Subject to your compliance with these Terms (including any other
          applicable terms and conditions), we grant to you limited,
          non-exclusive, revocable permission to make personal, non-commercial
          use of the Truthbrush Service and the Content (collectively,
          "Access"). This Access shall remain in effect unless and until
          terminated by you or Truthbrush . You agree that you will not
          redistribute or transfer the Truthbrush Service or the Content.
        </p>
        <p>Any software API or cloud services exposed on the Internet are proprietary and shall only be accessed with the official Truthbrush software. Any unauthorized access to software API or our cloud software service are strictly forbidden.</p>
        <p>
          The Truthbrush software applications and the Content are licensed, not
          sold or transferred to you, and Truthbrush and its licensors retain
          ownership of all copies of the Truthbrush software applications and
          Content even after installation on your Devices.
        </p>
        <h4>Truthbrush’s Proprietary Rights</h4>
        <p>
          The Truthbrush Service and the Content are the property of Truthbrush
          or Truthbrush’s licensors. All Truthbrush trademarks, service marks,
          trade names, logos, domain names, patents, intellectual properties and
          any other features of the Truthbrush brand ("Truthbrush Brand
          Features") are the sole property of Truthbrush. These Terms do not
          grant you any rights to use any Truthbrush Brand Features whether for
          commercial or non-commercial use.
        </p>
        <p>
          You agree to abide by the Truthbrush User Guidelines and not to use
          the Truthbrush Service, the Content, or any part thereof in any manner
          not expressly permitted by these Terms. You acknowledge that
          Truthbrush (Candibell, Inc) has the right to monitor use of the
          Services to ensure compliance with the Agreement.
        </p>

        <h1>Payments and Cancellation</h1>
        <h4>Billing</h4>
        <p>
          You may purchase Truthbrush directly from www.truthbrush.com or
          through a third party merchant either by:
        </p>
        <ul>
          <li>
            Paying an activation fee plus applicable taxes and shipping in
            advance and then a service fee on a recurring basis (Paid
            Subscription); or
          </li>
          <li>
            Pay in full plus applicable taxes and shipping in advance and access
            the Truthbrush app and services for as long as the Tracker allows
            (For Classic Tracker, this is when the battery depletes; For Pro
            Tracker, you can replace battery and continue using the tracker and
            software service)
          </li>
        </ul>
        <p>
          Tax rates are calculated based on the information you provide and the
          applicable rate at the time of your monthly charge.
        </p>
        <p>
          Shipping charge is based on your location and is charged based on
          service level (e.g. economy vs express). Truthbrush may offer free
          shipping when certain criteria is met (e.g. minimal order value).
          Truthbrush may use any carrier service of its choice to fulfill
          orders, as long as the expected service window and delivery time are
          reasonably satisfied.
        </p>
        <p>
          If you purchase access to a Paid Subscription through a third party,
          separate terms and conditions with such third party may apply to your
          use of the Truthbrush Service in addition to these Terms. Please
          contact the third party regarding any refunds or to manage your
          subscription. If you purchase a Paid Subscription using a code, gift
          card, pre-paid offer, or other offer provided or sold by or on behalf
          of Truthbrush for access to a Paid Subscription ("Codes"), you hereby
          agree to the Truthbrush Card Terms.
        </p>
        <p>
          We may bill you in multiples of month (i.e. monthly, quarterly,
          bi-yearly or yearly), based on the product you select and the Terms
          you agree to when purchasing from Truthbrush. We may need to keep your
          payment information on file and then charge to this payment instrument
          on a recurring basis. Truthbrush relies on Stripe for payment
          processing, secure tokenization and recurring billing. For information
          on Stripe and its practice and policy for data security and compliance
          certification, please visit www.stripe.com. Your payment information
          is not stored on or directly managed by the Truthbrush system.
        </p>
        <h4>Price and Tax Changes</h4>
        <p>
          Truthbrush may from time to time make changes to Paid Subscriptions,
          including activation fee, recurring subscription fees, the Trial
          Period, and will communicate any price changes on www.truthbrush.com.
          Price changes will take effect at the start of the next subscription
          period following the date of the price change and, by continuing to
          use the Truthbrush Service after the price change takes effect, you
          will have accepted the new price. If you do not agree to a price
          change, you can reject the change by unsubscribing from the applicable
          Paid Subscription prior to the price change going into effect.
        </p>
        <p>
          Tax rates are based on the rates applicable at the time of your
          monthly charge. These amounts can change over time with local tax
          requirements in your country, state, territory, county, or city. Any
          change in tax rate will be automatically applied based on the account
          information you provide.
        </p>
        <h4>Renewal and Cancellation</h4>
        <p>
          Your payment to Truthbrush or the third party through which you
          purchased the Paid Subscription will automatically renew, unless you
          cancel your Paid Subscription before the end of the then-current
          subscription period. Please see our FAQ tab on www.truthbrush.com or
          contact our customer support team (support@truthbrush.com) for
          instructions on how to cancel. The cancellation will take effect the
          day after the last day of the current subscription period. We do not
          provide refunds or credits for any partial subscription periods,
          except as expressly stated in these Terms.
        </p>
        <h4>Minimum Service Period</h4>
        <p>
          The Minimum Service Period, if applicable, is the shortest period you agree to pay for
          the Paid Subscription service, and is defined and agreed upon at purchase time. You may request to cancel at any time, however if you
          cancel before you reach the Minimum Service Period, we will continue
          billing you till the end of the Minimum Service Period, if and when a
          Minimum Service Period is applicable.
        </p>
        <h4>Trial Period</h4>
        <p>
          Your Paid Subscription may come with a free trial period. The free
          trial period begins at purchase, and continues for 14 days from that
          date. Once started, the complimentary 2 weeks cannot be paused or
          restarted. Your first recurring service fee will be billed when the
          trial period expires.
        </p>

        <h1>Content and Intellectual Property Rights</h1>
        <h2>Licenses that you grant to us</h2>
        <h4>User Content</h4>
        <p>
          You retain ownership of your User Content when you post it to the
          Truthbrush Service. However, in order for us to make your User Content
          available on the Truthbrush Service, we do need a limited license from
          you to that User Content. Accordingly, you hereby grant to Truthbrush
          a non-exclusive, transferable, sub-licensable, royalty-free, fully
          paid, irrevocable, worldwide license to reproduce, make available,
          perform and display, translate, modify, create derivative works from,
          distribute, and otherwise use any such User Content through any
          medium, whether alone or in combination with other Content or
          materials, in any manner and by any means, method or technology,
          whether now known or hereafter created, in connection with the
          Truthbrush Service. Where applicable and to the extent permitted under
          applicable law, you also agree to waive, and not to enforce, any
          "moral rights" or equivalent rights, such as your right to be
          identified as the author of any User Content, including Feedback, and
          your right to object to derogatory treatment of such User Content.
        </p>
        <h4>Feedback</h4>
        <p>
          If you provide ideas, suggestions, or other feedback in connection
          with your use of the Truthbrush Service or any Content ("Feedback"),
          such Feedback is not confidential and may be used by Truthbrush
          without restriction and without payment to you. Feedback is considered
          a type of User Content under these Terms.
        </p>
        <h4>Your Device</h4>
        <p>
          You also grant to us the right (1) to allow the Truthbrush Service to
          use the processor, bandwidth, and storage hardware on your Device in
          order to facilitate the operation of the Truthbrush Service, (2) to
          provide advertising and other information to you, and (3) to allow our
          business partners to do the same.
        </p>
        <h4>Content Experience</h4>
        <p>
          In any part of the Truthbrush Service, the Content that you access,
          including its selection and placement, may be influenced by commercial
          considerations, including Truthbrush's agreements with third parties.
        </p>
        <p>
          Some Content licensed by, provided to, created by, or otherwise made
          available by Truthbrush (e.g., podcasts or shows) may incorporate
          advertising or other promotional messages.
        </p>
        <p>
          Truthbrush endeavors to provide the most accurate Content for the
          behavioral and performance data of a user’s teeth brushing activities.
          Truthbrush uses proprietary system and processing algorithms to
          perform data analytics. Truthbrush offers however, no warranty to the
          accuracy, reliability, completeness, promptness to the
          Content or visualization of the Content.
        </p>

        <h1>Customer Support, Information, Questions, and Complaints</h1>
        <p>
          For customer support with account- and payment-related questions
          ("Customer Support Queries"), please use Customer Support resources
          listed on the Support section of our website or email us at
          support@truthbrush.com
        </p>
        <p>
          If you have any questions concerning the Truthbrush Service or these
          Terms (including any additional Truthbrush terms and conditions
          incorporated herein), please contact Truthbrush Customer Service by
          visiting the Support section of our website or by emailing us at
          support@truthbrush.com
        </p>
        <p>
          In addition, under California Civil Code Section 1789.3, you may
          contact the Complaint Assistance Unit of the Division of Consumer
          Services of the California Department of Consumer Affairs in writing
          at 1625 N. Market Blvd., Suite N 112, Sacramento, California 95834, or
          by telephone at 1-800-952-5210 in order to resolve a complaint
          regarding the service or to receive further information regarding use
          of the service.
        </p>

        <h1>Problems and Disputes</h1>

        <h4>Suspending and Terminating the Truthbrush Service</h4>
        <p>
          These Terms will continue to apply to you until terminated by either
          you or Truthbrush (Candibell, Inc). Truthbrush (Candibell, Inc) may
          terminate these Terms (including any additional terms and conditions
          incorporated herein) or suspend your access to the Truthbrush Service
          at any time if we believe you have breached any of these Terms, if we
          stop providing the Truthbrush Service or any material component
          thereof, or as we believe necessary to comply with applicable law. If
          you or Truthbrush (Candibell, Inc) terminate these Terms, or if
          Truthbrush (Candibell, Inc) suspends your access to the Truthbrush
          Service, you agree that Truthbrush (Candibell, Inc) shall have no
          liability or responsibility to you, and (except as expressly provided
          in these Terms) Truthbrush (Candibell, Inc) will not refund any
          amounts that you have already paid. You may terminate these Terms at
          any time, in which case you may not continue accessing or using the
          Truthbrush Service.
        </p>

        <h4>Account Delete</h4>
        <p>
          You may request to terminate your Truthbrush account at any time by
          writing to us at support@truthbrush.com. Or by pressing the “delete
          account” button within the Truthbrush mobile application. Once a
          request is received it will be conducted in the next update cycle and
          this action can not be undone.
        </p>

        <h1>Warranty Disclaimers</h1>

        <p>
          THE TRUTHBRUSH SERVICES ARE PROVIDED TO YOU “AS IS WITH ALL FAULTS”
          AND “AS AVAILABLE” WITHOUT WARRANTY OF ANY KIND, AND TRUTHBRUSH
          (CANDIBELL, INC) AND ITS SUBSIDIARIES, AFFILIATES, OFFICERS,
          DIRECTORS, EMPLOYEES, REPRESENTATIVES, AGENTS, PARTNERS, AND LICENSORS
          HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS WITH RESPECT TO THE
          SERVICES WHETHER EXPRESS OR IMPLIED AND EXPRESSLY DISCLAIMS ANY
          IMPLIED WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, SATISFACTORY QUALITY, AND NON-INFRINGEMENT. TRUTHBRUSH
          (CANDIBELL, INC) DOES NOT WARRANT AGAINST INTERFERENCE WITH YOUR
          ENJOYMENT OF THE SERVICES, THE AVAILABILITY OF CONTENT, THAT THE
          FUNCTIONS CONTAINED IN THE SERVICES WILL MEET YOUR REQUIREMENTS, THAT
          THE SERVICES WILL BE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, THAT
          THE OPERATION OF THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE,
          THAT DEFECTS IN THE SERVICES WILL BE CORRECTED, OR THAT THE FUNCTIONS
          CONTAINED IN THE SERVICES WILL FUNCTION WITH OTHER MOBILE APPS OR
          HARDWARE, OR WITHIN A SYSTEM. NO ORAL OR WRITTEN INFORMATION OR ADVICE
          GIVEN BY TRUTHBRUSH (CANDIBELL, INC) OR AN TRUTHBRUSH (CANDIBELL, INC)
          AUTHORIZED REPRESENTATIVE SHALL CREATE A WARRANTY. SOME JURISDICTIONS
          DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES OR LIMITATIONS ON
          APPLICABLE STATUTORY RIGHTS OF A CONSUMER, SO THE ABOVE EXCLUSION MAY
          NOT APPLY.
        </p>
        <p>
          Within the warranty period, and subject to terms and conditions in the Truthbrush Warranty policy below,
          Truthbrush(Candibell, Inc) shall repair or replace at no charge to you
          any components of the Product that fail the limited warranty provided.
          You shall be responsible for any related transportation charges.
          Replacement products may be new or refurbished at our discretion. This
          limited warranty does not apply to (i) normal wear and tear, including
          scratches and dents; (ii) consumable parts included in the Product,
          such as batteries, unless product damage has occurred due to a defect
          in materials or workmanship; (iii) damage resulting from your failure
          to use the Product in accordance with the instructions accompanying
          the Truthbrush Product or available at the website; (iv) damage
          resulting from an accident, flood, fire, misuse, or abuse; (v) damage
          resulting from service performed, or damage resulting from tampering
          with or alterations to the Product, by anyone not authorized by
          Truthbrush (Candibell, Inc); or (vi) use of the Product with any
          application or software other than the Truthbrush Mobile App.
        </p>
        <p>
          Truthbrush (Candibell, Inc) retains the exclusive right to repair or
          replace the Product, or offer a refund, at its sole discretion.
          Such remedy shall be your sole and exclusive remedy for any breach of
          this limited warranty.
        </p>
        <p>
          For detailed Truthbrush Warranty policy, please
          <a href="/#/warranty">click here</a>.
        </p>
        <h1>Limitation of Liability and Time for Filing a Claim</h1>
        <p>
          YOU AGREE THAT YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY PROBLEMS OR
          DISSATISFACTION WITH THE TRUTHBRUSH SERVICE IS TO UNINSTALL ANY
          TRUTHBRUSH SOFTWARE AND TO STOP USING THE TRUTHBRUSH SERVICE. YOU
          AGREE THAT TRUTHBRUSH (CANDIBELL, INC) HAS NO OBLIGATION OR LIABILITY
          ARISING FROM OR RELATED TO THIRD-PARTY APPLICATIONS OR THE CONTENT
          THEREOF MADE AVAILABLE THROUGH OR IN CONNECTION WITH THE TRUTHBRUSH
          SERVICE, AND WHILE YOUR RELATIONSHIP WITH SUCH THIRD-PARTY
          APPLICATIONS MAY BE GOVERNED BY SEPARATE AGREEMENTS WITH SUCH THIRD
          PARTIES, YOUR SOLE AND EXCLUSIVE REMEDY, AS WITH RESPECT TO TRUTHBRUSH
          (CANDIBELL, INC), FOR ANY PROBLEMS OR DISSATISFACTION WITH ANY
          THIRD-PARTY APPLICATIONS OR THE CONTENT THEREOF, IS TO UNINSTALL OR
          STOP USING SUCH THIRD-PARTY APPLICATIONS.
        </p>
        <p>
          IN NO EVENT WILL TRUTHBRUSH (CANDIBELL, INC), ITS OFFICERS,
          SHAREHOLDERS, EMPLOYEES, AGENTS, DIRECTORS, SUBSIDIARIES, AFFILIATES,
          SUCCESSORS, ASSIGNS, SUPPLIERS, OR LICENSORS BE LIABLE FOR (1) ANY
          INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE, EXEMPLARY, OR CONSEQUENTIAL
          DAMAGES; (2) ANY LOSS OF USE, DATA, BUSINESS, OR PROFITS (WHETHER
          DIRECT OR INDIRECT), IN ALL CASES ARISING OUT OF THE USE OF OR
          INABILITY TO USE THE TRUTHBRUSH SERVICE, DEVICES, THIRD-PARTY
          APPLICATIONS, OR THIRD-PARTY APPLICATION CONTENT, REGARDLESS OF LEGAL
          THEORY, WITHOUT REGARD TO WHETHER TRUTHBRUSH (CANDIBELL, INC) HAS BEEN
          WARNED OF THE POSSIBILITY OF THOSE DAMAGES, AND EVEN IF A REMEDY FAILS
          OF ITS ESSENTIAL PURPOSE; OR (3) AGGREGATE LIABILITY FOR ALL CLAIMS
          RELATING TO THE TRUTHBRUSH SERVICE, THIRD-PARTY APPLICATIONS, OR
          THIRD-PARTY APPLICATION CONTENT MORE THAN THE GREATER OF (A) THE
          AMOUNTS PAID BY YOU TO TRUTHBRUSH (CANDIBELL, INC) DURING THE SIX (6)
          MONTH PRIOR TO THE FIRST CLAIM; OR $30.00 US DOLLARS.
        </p>

        <h1>Return and Refund</h1>
        <p>
          For our Return and Refund policy, please
          <a href="/#/refund">click here</a>.
        </p>

        <h1>Third Party Rights</h1>

        <p>
          If you have downloaded any of our mobile software applications (each,
          an "App") from the Apple Inc. ("Apple") App Store or if you are using
          the App on an iOS device, you acknowledge that you have read,
          understood, and agree to the following notice regarding Apple. These
          Terms are between you and Truthbrush (Candibell, Inc) only, not with
          Apple, and Apple is not responsible for the Truthbrush Service and the
          content thereof. Apple has no obligation whatsoever to furnish any
          maintenance and support services with respect to the Truthbrush
          Service. In the event of any failure of the Truthbrush Service to
          conform to any applicable warranty, you may notify Apple and Apple
          will refund the applicable purchase price for the App to you; and, to
          the maximum extent permitted by applicable law, Apple has no other
          warranty obligation whatsoever with respect to the Truthbrush Service.
          Apple is not responsible for addressing any claims by you or any third
          party relating to the Truthbrush Service or your possession or use of
          the Truthbrush Service, including: (1) product liability claims; (2)
          any claim that the Truthbrush Service fails to conform to any
          applicable legal or regulatory requirement; (3) claims arising under
          consumer protection or similar legislation; and (4) claims with
          respect to intellectual property infringement. Apple is not
          responsible for the investigation, defense, settlement, and discharge
          of any third-party claim that the Truthbrush Service or your
          possession and use of the App infringe that third party's intellectual
          property rights. You agree to comply with any applicable third-party
          terms, when using the Truthbrush Service. Apple, and Apple's
          subsidiaries, are third-party beneficiaries of these Terms, and upon
          your acceptance of these Terms, Apple will have the right (and will be
          deemed to have accepted the right) to enforce these Terms against you
          as a third-party beneficiary of these Terms.
        </p>

        <h1>Indemnification</h1>
        <p>
          You agree to indemnify and hold Truthbrush (Candibell, Inc) harmless
          from and against all damages, losses, and expenses of any kind
          (including reasonable attorney fees and costs) arising out of or
          related to: (1) your breach of any of these Terms (including any
          additional Truthbrush (Candibell, Inc) terms and conditions
          incorporated herein); (2) any User Content you post or otherwise
          contribute; (3) any activity in which you engage on or through the
          Truthbrush Service; and (4) your violation of any law or the rights of
          a third party.
        </p>

        <h1>Governing Law, Mandatory Arbitration and Venue</h1>

        <p>
          These Terms are governed by and shall be construed in accordance with
          the laws of the State of Massachusetts, United States of America,
          without regard to California's choice or conflicts of law principles.
          Further, you and Truthbrush (Candibell, Inc) agree to the jurisdiction
          of the federal and state courts located in Boston, Massachusetts, to
          resolve any dispute, claim, or controversy that relates to or arises
          in connection with these Terms or the Truthbrush Service that is not
          subject to mandatory arbitration under the Arbitration Agreement
          below, and waive any jurisdictional, venue or inconvenient forum
          objections to such courts.
        </p>

        <h1>Arbitration Agreement</h1>

        <p>
          This Arbitration Agreement section sets forth the terms and conditions
          pursuant to which disputes, claims and controversies between you and
          Truthbrush will be resolved through arbitration ("Arbitration
          Agreement")
        </p>
        <h4>Dispute Resolution and Arbitration</h4>
        <p>
          You and Truthbrush (Candibell, Inc) agree that any dispute, claim, or
          controversy between you and Truthbrush (Candibell, Inc) arising in
          connection with or relating in any way to these Terms or to your
          relationship with Truthbrush (Candibell, Inc) as a user of the
          Truthbrush Service (whether based in contract, tort, statute, fraud,
          misrepresentation, or any other legal theory, and whether the claims
          arise during or after the termination of these Terms) will be
          determined by mandatory binding individual (not class) arbitration.
          You and Truthbrush (Candibell, Inc) further agree that the arbitrator
          shall have the exclusive power to rule on his or her own jurisdiction,
          including any objections with respect to the existence, scope or
          validity of the Arbitration Agreement or to the arbitrability of any
          claim or counterclaim. THERE IS NO JUDGE OR JURY IN ARBITRATION, AND
          COURT REVIEW OF AN ARBITRATION AWARD IS LIMITED. The arbitrator must
          follow these Terms and can award the same damages and relief as a
          court (including attorney fees and costs only where allowable under
          applicable law), except that the arbitrator may not award any relief,
          including declaratory or injunctive relief, benefiting anyone but the
          parties to the arbitration. This arbitration provision will survive
          termination of these Terms.
        </p>
        <h4>Exceptions</h4>
        <p>
          You and Truthbrush (Candibell, Inc) both agree that nothing in this
          Arbitration Agreement will be deemed to waive, preclude, or otherwise
          limit either of our rights, at any time, to bring an individual action
          (1) in a U.S. small claims court or (2) in a court of law, in
          accordance with the jurisdiction and venue described in the Dispute
          Resolution and Arbitration section above, seeking (a) only temporary
          or preliminary individualized injunctive relief, pending a final
          ruling from the arbitrator or (b) public injunctive relief, pending a
          ruling on the substance of such claim from the arbitrator. In
          addition, this Arbitration Agreement doesn't stop you or us from
          bringing issues to the attention of federal, state, or local agencies.
          Such agencies can, if the law allows, seek relief against us on your
          behalf (or vice versa).
        </p>

        <h4>No Class Or Representative Proceedings (Class Action Waiver)</h4>
        <p>
          YOU AND TRUTHBRUSH (CANDIBELL, INC) AGREE THAT EACH MAY BRING CLAIMS
          AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A
          PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE
          ACTION. Unless both you and Truthbrush (Candibell, Inc) agree, no
          arbitrator or judge may consolidate more than one person's claims or
          otherwise preside over any form of a representative or class
          proceeding. The arbitrator may award injunctive relief only in favor
          of the individual party seeking relief and only to the extent
          necessary to provide relief warranted by that party's individual
          claim. If a court decides that applicable law precludes enforcement of
          any of this paragraph's limitations as to a particular claim for
          relief, then that claim (and only that claim) must be severed from the
          arbitration and may be brought in court.
        </p>
        <h4>Arbitration Rules</h4>
        <p>
          Either you or we may start arbitration proceedings. Any arbitration
          between you and Truthbrush will take place under the Consumer
          Arbitration Rules of the American Arbitration Association ("AAA") then
          in force (the "AAA Rules"), as modified by this Arbitration Agreement.
          You and Truthbrush (Candibell, Inc) agree that the Federal Arbitration
          Act applies and governs the interpretation and enforcement of this
          provision (despite the choice of law provision above). The AAA Rules,
          as well as instructions on how to file an arbitration proceeding with
          the AAA, appear at adr.org.
        </p>

        <p>
          Any arbitration hearings will be conducted by phone or videoconference
          to the extent possible, but if the arbitrator determines that a
          hearing should be conducted in person, the locale for such hearing
          shall be determined by the arbitrator in accordance with the AAA
          Rules.
        </p>
        <h4>Notice</h4>
        <p>
          A party who intends to seek arbitration must first send a written
          notice of the dispute to the other, by electronic mail to
          support@truthbrush.com and by certified mail, Federal Express, UPS, or
          Express Mail (signature required) to the address below ("Notice").
          Truthbrush (Candibell, Inc)’s address for Notice is: Candibell, Inc,
          Legal Department, 600 Suffolk St #250, Lowell, MA 01854, USA. The
          Notice must (1) describe the nature and basis of the claim or dispute;
          and (2) set forth the specific relief sought ("Demand"). We agree to
          use good faith efforts to resolve the claim directly, but if we do not
          reach an agreement to do so within 30 days after the Notice is
          received, you or Truthbrush (Candibell, Inc) may commence an
          arbitration proceeding. During the arbitration, the amount of any
          settlement offer made by you or Truthbrush (Candibell, Inc) shall not
          be disclosed to the arbitrator until after the arbitrator makes a
          final decision and award, if any. In the event our dispute is finally
          resolved through arbitration in your favor, and the arbitrator issues
          you an award that is greater than the value of Truthbrush (Candibell,
          Inc)’s last written settlement offer, then Truthbrush (Candibell, Inc)
          will instead pay you either the amount of the award or $80,
          whichever is greater. All documents and information disclosed in the
          course of the arbitration shall be kept strictly confidential by the
          recipient and shall not be used by the recipient for any purpose other
          than for purposes of the arbitration or the enforcement of the
          arbitrator's decision and award and shall not be disclosed except in
          confidence to persons who have a need to know for such purposes or as
          required by applicable law.
        </p>

        <h4>Enforceability</h4>

        <p>
          If this Arbitration Agreement is invalidated in whole or in part, the
          parties agree that the exclusive jurisdiction and venue described in
          the 'Governing law and jurisdiction' section above shall govern with
          respect to any aspect of any dispute, claim or controversy that, as a
          result of such invalidation, is no longer governed by this Arbitration
          Agreement.
        </p>
        <h1>United States Operation</h1>
        <p>
          This Services are controlled by Truthbrush from its offices within the
          United States of America. Truthbrush makes no representation that the
          Content or the Services are appropriate or available for use in other
          locations. Access to or use of the Content or the Services from
          territories where such access or use is illegal is prohibited. Those
          who choose to access the Services from locations outside of the United
          States do so on their own initiative and are responsible for
          compliance with applicable local laws. You may not use or export the
          Content in violation of U.S. export laws and regulations.
        </p>
        <h1>About These Terms</h1>
        <p>
          Under applicable law, you may have certain rights that can't be
          limited by a contract. These Terms are in no way intended to restrict
          those rights.
        </p>
        <h4>Changes</h4>
        <p>
          We may make changes to these Terms (including any additional
          Truthbrush (Candibell, Inc) terms and conditions incorporated by
          reference herein) from time to time by notifying you of such changes
          by any reasonable means, including by posting the revised Terms on the
          applicable Truthbrush Service (provided that, for material changes, we
          will seek to supplement such notice by email, an in-service pop-up
          message or other prominent notice within the Service, or other means).
          Any such changes will not apply to any dispute between you and us
          arising prior to the date on which the Terms were changed. Your use of
          the Truthbrush Service following any changes to these Terms will
          constitute your acceptance of such changes. If you do not wish to
          continue using the Truthbrush Service under the updated Terms, you may
          terminate your account by contacting us. The effective date set forth
          at the top of this document indicates when these Terms were last
          changed.
        </p>
        <h4>Entire agreement</h4>

        <p>
          Other than as stated in this section or as explicitly agreed upon in
          writing between you and Truthbrush (Candibell, Inc), these Terms
          constitute all the terms and conditions agreed upon between you and
          Truthbrush (Candibell, Inc) and supersede any prior agreements in
          relation to the subject matter of these Terms, whether written or
          oral.
        </p>
        <h4>Severability and waiver</h4>
        <p>
          Unless as otherwise stated in these Terms, should any provision of
          these Terms be held invalid or unenforceable for any reason or to any
          extent, the remaining provisions of these Terms will not be affected,
          and the application of that provision shall be enforced to the extent
          permitted by law.
        </p>
        <p>
          Any failure by Truthbrush (Candibell, Inc) or any third-party
          beneficiary to enforce these Terms or any provision thereof shall not
          waive Truthbrush (Candibell, Inc)’s or the applicable third-party
          beneficiary's right to do so.
        </p>
        <h4>Assignment</h4>
        <p>
          Truthbrush (Candibell, Inc) may assign any or all of these Terms, and
          may assign or delegate, in whole or in part, any of its rights or
          obligations under these Terms. You may not assign these Terms, in
          whole or in part, nor transfer or sub-license your rights under these
          Terms, to any third party.
        </p>
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
  },
};
</script>

<style lang="scss">
.term_service h2 {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .term_service h2,
  .term_service h4 {
    text-align: center;
  }
}
</style>